<div class="select-category" [ngClass]="{ 'select-category-mobile': isLgMobile() }">
  @if (!isLgMobile()) {
    @for (column of categoriesTree; track column; let level = $index) {
      <div class="select-category-column crm-scroll">
        <ng-container *ngTemplateOutlet="categoryListTemplate; context: { level: level, column: column }" />
      </div>
    }
  } @else {
    @if (selectedCategories.length) {
      <div class="select-category-mobile-header">
        <app-button btnType="icon" customClass="icon-xxs" (onChangeClick)="goBack()">
          <app-icon class="icon-xxs">arrow_back_ios_new</app-icon>
        </app-button>
        <div class="select-category-mobile-title">
          {{ selectedCategories[selectedCategories.length - 1].name }}
        </div>
      </div>
    }
    <div class="select-category-column crm-scroll">
      <ng-container
        *ngTemplateOutlet="
          categoryListTemplate;
          context: {
            level: currentLevel,
            column: categoriesTree[currentLevel],
          }
        "
      />
    </div>
  }

  <ng-template #categoryListTemplate let-column="column" let-level="level">
    @for (category of column; track category) {
      <div
        class="select-category-column-item"
        [ngClass]="{
          'select-category-column-item-selected':
            (selectedCategories[level] && selectedCategories[level].category_id) === category.category_id,
        }"
        (click)="onCategorySelect(level, category)"
      >
        <span>{{ category.name }}</span>
        @if (!category.is_leaf) {
          <app-icon class="select-category-column-item-arrow">keyboard_arrow_right</app-icon>
        }
      </div>
    }
  </ng-template>
</div>
